export const X_ICON = `<span class=" absolute top-0 right-0 m-4">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      aria-hidden="true"
      class="h-6 w-6 cursor-pointer text-stone-400 hover:text-stone-600 dark:hover:text-stone-200"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      ></path>
    </svg></span>`;
